import { ConfiguredPermission } from './configured-permission';

export class ConfiguredPermissions {
  constructor(
    public customerId: string,
    public groups: { [key: string]: ConfiguredPermission },
    public users: { [key: string]: ConfiguredPermission }
  ) {} // Dictionary<Guid, ConfiguredPermission>
}
